import { useState } from 'react'
import { mt } from '../lib/i18n'

/** Shows the translation by default, says it is translated, and lets the reader look at the original. */
export function TranslationNote({from,showing,onToggle}:{from:string|null;showing:boolean;onToggle:()=>void}){
 const lang=mt(from&&from.startsWith('es')?'langName_es':'langName_en')
 return <small className="tr-note">{mt('translatedFrom').replace('{lang}',lang)} · <button type="button" className="link" onClick={onToggle}>{showing?mt('showOriginal'):mt('showTranslation')}</button></small>
}

/** One text block with its translation. Without a translation it is just the text. */
export default function Translated({text,translated,from,as:Tag='p',className}:{text:string;translated?:string|null;from?:string|null;as?:'p'|'span';className?:string}){
 const [original,setOriginal]=useState(false)
 if(!translated)return <Tag className={className}>{text}</Tag>
 return <><Tag className={className}>{original?text:translated}</Tag><TranslationNote from={from??null} showing={!original} onToggle={()=>setOriginal(x=>!x)}/></>
}
